// opervex-frontend/src/pages/Dashboard.js

import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import useOpervex from "../hooks/useOpervex";

const Dashboard = () => {
  const OpervexAPI = useOpervex();

  const [report, setReport] = useState(null);

  useEffect(() => {
    const loadReport = async () => {
      try {
        const result = await OpervexAPI.Dashboard.PowerBI.getToken();

        setReport(result);
      } catch (err) {
        console.error(err);
      }
    };

    loadReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!report) {
    return (
      <Container fluid className="p-3">
        Carregando relatório...
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id: report.reportId,
          embedUrl: report.embedUrl,
          accessToken: report.embedToken,
          tokenType: models.TokenType.Embed,

          settings: {
            panes: {
              filters: {
                visible: false,
              },
              pageNavigation: {
                visible: true,
              },
            },
          },
        }}
        cssClassName="powerbi-report"
        eventHandlers={
          new Map([
            [
              "loaded",
              () => {
                console.log("Relatório carregado");
              },
            ],
            [
              "rendered",
              () => {
                console.log("Relatório renderizado");
              },
            ],
            [
              "error",
              (event) => {
                console.error(event.detail);
              },
            ],
          ])
        }
      />
    </Container>
  );
};

export default Dashboard;
